import axios from 'axios';

import url from './baseURL';
import { configureRightsPreviewTransport, prepareRightsPreviewRequest, assertRightsPreviewCurrent } from './rightsPreviewTransport';

//const token = localStorage.getItem("tokenMinu");


const api = axios.create({
    baseURL: url.api,
    headers: {
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Headers': 'Content-Type, Authorization',
        'Accept': 'application/json',
    }
});
configureRightsPreviewTransport({ apiBaseURL: url.api });

// Interceptor → ajoute le token à chaque requête
api.interceptors.request.use(config => {
    const token = localStorage.getItem("tokenMinu")
    if (token) {
        config.headers.Authorization = `Bearer ${token}`
    }
    return prepareRightsPreviewRequest(config)
})

api.interceptors.response.use(response => {
    assertRightsPreviewCurrent(response.config)
    return response
}, error => {
    if (error.config) assertRightsPreviewCurrent(error.config)
    return Promise.reject(error)
})

export default api;
